///
/// EarthBrowser - Data Provider Registry
///
/// Global registry for managing data provider instances
/// Created by Matt Giger on December 17, 2025
/// Copyright (c) 2025 Geodata Labs
///

import type { IDataProvider } from './types'

/**
 * Global registry for data providers
 * Since data providers contain non-serializable data, they cannot be stored in Redux
 * This registry provides a centralized location to store and retrieve provider instances
 */
class DataProviderRegistryClass {
	private providers = new Map<string, IDataProvider>()

	/**
	 * Register a data provider with a unique ID
	 */
	register(id: string, provider: IDataProvider): void {
		this.providers.set(id, provider)
	}

	/**
	 * Get a data provider by ID
	 */
	get(id: string): IDataProvider | undefined {
		return this.providers.get(id)
	}

	/**
	 * Check if a provider exists
	 */
	has(id: string): boolean {
		return this.providers.has(id)
	}

	/**
	 * Unregister a data provider
	 */
	unregister(id: string): void {
		this.providers.delete(id)
	}

	/**
	 * Get all registered provider IDs
	 */
	getAllIds(): string[] {
		return Array.from(this.providers.keys())
	}

	/**
	 * Clear all providers
	 */
	clear(): void {
		this.providers.clear()
	}
}

// Export singleton instance
export const DataProviderRegistry = new DataProviderRegistryClass()

